import React from 'react';

export const Wildcard = () => {
  return <div className="container">Page not found!</div>;
};
